import { getQaSelector } from '../../../utils/common'

import { QA_NAME_HEADER_SEPARATOR } from './HeaderSeparator.constants'

import * as styles from './HeaderSeparator.module.css'

function HeaderSeparator({ children, className = styles.HeaderSeparator }) {
  const qaProps = getQaSelector({ value: QA_NAME_HEADER_SEPARATOR })

  return (
    <header {...qaProps} className={className}>
      {children}
    </header>
  )
}

export default HeaderSeparator
